

































import { Component, Prop, Vue } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { IAnnouncement } from 'admiral-core';
import { Util } from '@/utils/Util';
import { EyeIcon, TrashIcon } from 'vue-feather-icons';

@Component({
  components: {
    EyeIcon,
    TrashIcon,
  },
})
export default class AnnouncementTable extends Vue {
  @Prop({ type: Array, required: true })
  announcements!: IAnnouncement[];

  formatDate(date: Date) {
    return Util.formatDate(date);
  }
}
